import { render, staticRenderFns } from "./EventPasses.vue?vue&type=template&id=33dba165"
import script from "./EventPasses.vue?vue&type=script&lang=js"
export * from "./EventPasses.vue?vue&type=script&lang=js"
import style0 from "./EventPasses.vue?vue&type=style&index=0&id=33dba165&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports